<section
  (keydown.arrowDown)="focusNext('down', $event)"
  (keydown.arrowLeft)="focusNext('left', $event)"
  (keydown.arrowRight)="focusNext('right', $event)"
  (keydown.arrowUp)="focusNext('up', $event)"
  (keydown.escape)="close($event)"
  (mousedown)="$event.stopPropagation()"
  *ngIf="mode === 'single'"
  [attr.aria-label]="
    errorState
      ? errorMessage
      : 'Calendar expanded, use arrow keys to select date'
  "
  [attr.tabindex]="_openCalendarFlag ? '0' : '-1'"
  [class.calendar-container__dropdown]="inDropdown"
  class="calendar-container"
  role="application"
>
  <span aria-live="assertive" class="calendar-container__sr-only" role="status">
    {{ selectedScreenReaderText }}
  </span>
  <div class="calendar-container__body">
    <div class="calendar-table">
      <button
        (keydown.enter)="close($event)"
        (mousedown)="close($event)"
        *ngIf="showCloseButton"
        aria-label="Close Calendar"
        class="calendar--close-btn"
        type="button"
      >
        <i
          (mousedown)="focus($event)"
          aria-hidden="true"
          class="idp-close-icon"
        ></i>
      </button>

      <div class="calendar--arrows">
        <button
          (keydown.enter)="decrementMonthOffset($event)"
          (keydown.shift.tab)="tabPrevious($event)"
          (keydown.tab)="tabNext($event)"
          (mousedown)="decrementMonthOffset($event)"
          [attr.aria-label]="
            (disablePrevious && isOriginalDateDisplayed()) || hideLeftArrow
              ? 'Previous month not available'
              : 'Previous month'
          "
          class="calendar--arrows-btn-left"
          data-test-left-button="true"
        >
          <i class="idp-icon-calendar-arrow-left"></i>
        </button>
        <div class="calendar--date-title" data-test-calendar-title="true">
          {{ monthLabel }} {{ yearLabel }}
        </div>
        <button
          (keydown.enter)="incrementMonthOffset($event)"
          (keydown.shift.tab)="tabPrevious($event)"
          (keydown.tab)="tabNext($event)"
          (mousedown)="incrementMonthOffset($event)"
          [attr.aria-label]="
            (disableFuture && isOriginalDateDisplayed()) || hideRightArrow
              ? 'Next month not available'
              : 'Next month'
          "
          aria-label="Next Month"
          class="calendar--arrows-btn-right"
          data-test-right-button="true"
        >
          <i class="idp-icon-calendar-arrow-right"></i>
        </button>
      </div>

      <div class="calendar--days">
        <div class="calendar--days-of-week">s</div>
        <div class="calendar--days-of-week">m</div>
        <div class="calendar--days-of-week">t</div>
        <div class="calendar--days-of-week">w</div>
        <div class="calendar--days-of-week">t</div>
        <div class="calendar--days-of-week">f</div>
        <div class="calendar--days-of-week">s</div>
      </div>
      <div class="calendar-table__body" role="presentation">
        <div *ngFor="let week of calendarModel" class="calendar-table__row">
          <ng-container *ngFor="let day of week">
            <div
              (keydown.enter)="
                selectValue(
                  $event,
                  {
                    id: id,
                    value: day?.value
                  },
                  day?.type
                )
              "
              (keydown.tab)="goToNextElement($event)"
              (mousedown)="
                selectValueAndFocus(
                  $event,
                  {
                    id: id,
                    value: day?.value || ''
                  },
                  day?.type || ''
                )
              "
              [attr.aria-label]="day?.aria"
              [attr.data-calendar-date]="day?.value"
              [attr.data-test-current-date]="
                day?.type === 'current' ? true : null
              "
              [attr.tabindex]="hasInactiveClass(day) ? '-1' : '0'"
              [class.calendar-table__anchor-date]="_anchorDate === day?.value"
              [class.calendar-table__event]="selectedDate === day?.value"
              [class.calendar-table__focused]="day?.value === focusedDate"
              [class.calendar-table__active]="!hasInactiveClass(day)"
              [class.calendar-table__inactive]="
                day?.type === 'previous' ||
                isMoreOrLessThanAllowed(day) ||
                day?.type === 'next' ||
                (disablePrevious &&
                  isPrevious(day) &&
                  isOriginalDateDisplayed()) ||
                (disableFuture && isFuture(day) && isOriginalDateDisplayed())
              "
              [ngClass]="'calendar-table-day__' + day?.type + '--' + day?.label"
              class="calendar-table__col"
              role="link"
            >
              <div class="calendar-table__item">
                <span>{{ day?.label }}</span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="showFooter" class="calendar__footer">
    <div class="calendar__footer--left">
      <idp-checkbox-standard ariaLabel="clear" hidden></idp-checkbox-standard>
    </div>
    <div class="calendar__footer--right">
      <button
        *ngIf="!hideClearButton"
        (click)="clear($event)"
        (keydown.enter)="clear($event)"
        (keydown.shift.tab)="tabPrevious($event)"
        (keydown.tab)="tabNext($event)"
        (keyup.Space)="clear($event)"
        class="calendar__footer-btn calendar__footer-btn-clear mr-3"
        data-test-clear-button="true"
        type="button"
      >
        Clear
      </button>
      <button
        *ngIf="!hideDoneButton"
        (click)="close($event)"
        (keydown.enter)="close($event)"
        (keydown.shift.tab)="tabPrevious($event)"
        (keydown.tab)="tabNext($event)"
        (keyup.Space)="close($event)"
        class="calendar__footer-btn-done"
        data-test-done-button="true"
        type="button"
      >
        done
      </button>
    </div>
  </div>
</section>
